import React, { Component } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import config from '../../config/api';
// import ReactPlayer from 'react-player';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Template from 'components/Template';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
// import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import ScrollToTopOnMount from '../ScrollToTopOnMount';
import { withStyles } from '@material-ui/core/styles';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import Hidden from '@material-ui/core/Hidden';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Popper from '@material-ui/core/Popper';

import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ListItemIcon from '@material-ui/core/ListItemIcon';

// import printJS from 'print-js';
// import IconSetMenu from '../Icon/IconSetMenu';
import Spinner from '../Spinner';

// import './Fiche.css';

import { fetchData, getDataFiche, getLoadingError } from '../../ducks/asyncFetcher';

import IconPrint from '@material-ui/icons/Print';
import IconPlay from '@material-ui/icons/PlayCircleFilledWhite';
// import IconLanguage from '@material-ui/icons/Language';
// import IconChat from '@material-ui/icons/ChatBubbleOutline';

// import IconCar from '@material-ui/icons/DirectionsCar';
// import IconSalary from '@material-ui/icons/EuroSymbol';
// import IconCalendar from '@material-ui/icons/DateRange';
// import IconMobility from '@material-ui/icons/LocationCity';
// import IconCity from '@material-ui/icons/Place';
import IconMore from '@material-ui/icons/ExpandMore';
import IconLess from '@material-ui/icons/ExpandLess';

import BlockRatio from '../BlockRatio/BlockRatio';

const AF_KEY = 'fiche';

const styles = (theme) => {
  return {
    root: {
      maxWidth: 1280,
      margin: '0 auto',
      paddingLeft: 10,
      paddingRight: 10,
      position: 'relative',
      '& .MuiTypography-h1': {},
      '& .MuiTypography-h2': {
        // marginTop: theme.spacing(4),
        marginLeft: theme.spacing(2),
        marginBottom: 0,
        fontWeight: 700,
        fontSize: '1.3rem',
        [theme.breakpoints.down('sm')]: {
          marginTop: theme.spacing(4),
          fontSize: '1.3rem',
          marginLeft: theme.spacing(2),
        },
      },
      '& .MuiTypography-subtitle1': {
        marginTop: theme.spacing(4),
        marginLeft: theme.spacing(2),
        marginBottom: 0,
        fontSize: '1.3rem',
        [theme.breakpoints.down('sm')]: {
          marginTop: theme.spacing(4),
          marginLeft: theme.spacing(2),
        },
      },
      '& .MuiTypography-h3': {
        marginLeft: theme.spacing(0),
        [theme.breakpoints.down('sm')]: {
          fontSize: '1.6rem',
          '&:after': {
            width: '60px',
          },
        },
      },
      '& .MuiListItemIcon-root': {
        minWidth: 30,
      },
      '& .MuiTypography-subtitle2': {
        fontSize: '1rem',
      },
    },
    mainTitle: {
      [theme.breakpoints.down('sm')]: {
        width: '80%',
        margin: '0 auto',
      },
    },
    inline: {
      display: 'inline-block',
      verticalAlign: 'middle',
    },
    reversedButton: {
      backgroundColor: '#fff',
      color: theme.palette.secondary.main,
      '&:hover': {
        color: '#fff',
        backgroundColor: theme.palette.secondary.main,
      },
    },
    mainPrevious: {
      marginRight: theme.spacing(2),
      backgroundColor: '#fff',
      boxShadow: theme.shadows[1],
      marginTop: -3,
      [theme.breakpoints.down('sm')]: {
        marginRight: theme.spacing(1),
        position: 'absolute',
        left: -40,
        top: 2,
      },
    },
    mainNext: {
      marginLeft: theme.spacing(2),
      backgroundColor: '#fff',
      boxShadow: theme.shadows[1],
      marginTop: -3,
      [theme.breakpoints.down('sm')]: {
        marginLeft: theme.spacing(1),
        position: 'absolute',
        right: -40,
        top: 2,
      },
    },
    printIcon: {
      float: 'right',
      marginTop: -6,
      border: '1px #D9D5D3 solid',
      width: 40,
      height: 40,
      // marginRight: 10,
    },
    padderLeftSide: {
      padding: '0 5%',
      backgroundColor: '#fff',
      boxShadow: '0 0 10px #e8e8e8',
      paddingBottom: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    },
    buttonBig: {
      width: '90%',
      marginLeft: '5%',
      borderRadius: 90,
      paddingTop: 15,
      paddingBottom: 15,
      marginBottom: 20,
      '&:last-of-type': {
        marginBottom: 0,
      },
      [theme.breakpoints.down('md')]: {
        marginTop: 10,
        marginBottom: 10,
      },
      [theme.breakpoints.down('sm')]: {
        paddingTop: 10,
        paddingBottom: 10,
        marginBottom: 10,
      },
    },
    videoWrapper: {
      paddingLeft: 30,
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 0,
      },
    },
    iconsRow: {
      // marginTop: theme.spacing(5),
      marginBottom: theme.spacing(3),
      borderRadius: 6,
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(2),
      },
      width: '100%',
      padding: '30px 20px',
      textAlign: 'center',
      // backgroundColor: '#F6F6F6',
      textTransform: 'uppercase',
      color: '#322F30',
      fontFamily: 'Megatype',
      '& img': {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginTop: -5,
        marginRight: 10,
      },
      '& div': {
        [theme.breakpoints.down('sm')]: {
          marginBottom: theme.spacing(2),
          textAlign: 'center',
        },
        [theme.breakpoints.down('xs')]: {
          marginBottom: theme.spacing(2),
          textAlign: 'left',
        },
      },
    },
    iconLegend: {
      fontWeight: 700,
      color: '#332F30',
    },
    videoPlaceHolder: {
      height: '100%',
    },
    videoSelector: {
      position: 'relative',
      // '& .MuiSvgIcon-root': {
      //   display: 'inline-block',
      //   verticalAlign: 'middle',
      //   marginTop: -5,
      //   marginRight: 5,
      // },
    },
    content: {},
    contentRow: {
      marginBottom: theme.spacing(6),
      [theme.breakpoints.down('sm')]: {
        marginBottom: 0,
      },
      '& div': {
        [theme.breakpoints.down('sm')]: {
          marginBottom: theme.spacing(4),
        },
      },
      '& div > .MuiPaper-root': {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        boxShadow: '0 0 50px #e8e8e8',
        height: 'calc(100% - ' + theme.spacing(4) + 'px)',
      },
      '&  div:first-of-type > .MuiPaper-root': {
        marginRight: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
          marginLeft: theme.spacing(2),
          marginRight: theme.spacing(2),
        },
      },
      '&  div:last-of-type > .MuiPaper-root': {
        marginLeft: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
          marginLeft: theme.spacing(2),
          marginRight: theme.spacing(2),
        },
      },
      '& ul': {
        paddingLeft: 20,
        margin: 0,
      },
      '& ul li': {
        listStyle: 'none',
        lineHeight: '1.5em',
      },
      '& ul li:before': {
        content: '"\\2022"',
        color: theme.palette.secondary.main,
        // fontSize: '1rem',
        verticalAlign: 'middle',
        marginTop: -3,
        display: 'inline-block' /* Needed to add space between the bullet and the text */,
        fontSize: '1.5rem',
        width: '0.4em' /* Also needed for space (tweak if needed) */,
        marginLeft: '-0.8em' /* Also needed for space (tweak if needed) */,
      },
    },
    contentPrinting: {
      '& div > .MuiPaper-root': {
        boxShadow: theme.shadows[5],
      },
    },
    contentSpacer: {
      // border: '1px red solid',
      height: 1060,
    },
    paperContent: {
      transition: [
        theme.transitions.create('height', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      ],
    },
    paperOverflows: {
      marginBottom: 30,
    },
    paperHidden: {
      height: 119,
      overflow: 'hidden',
    },
    paperWrapper: {
      position: 'relative',
    },
    paperMore: {
      position: 'absolute',
      bottom: 10,
      right: 10,
      marginTop: 10,
      fontWeight: 700,
      color: '#747273',
      backgroundColor: 'transparent',
      border: 'none',
      '& .MuiSvgIcon-root': {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginTop: -1,
        border: '1px #D9D5D3 solid',
        color: theme.palette.secondary.main,
        borderRadius: 90,
        fontWeight: 'bold',
      },
    },
    videoMore: {
      color: '#747273',
      backgroundColor: 'transparent',
      border: 'none',
      '& .MuiSvgIcon-root': {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginTop: -1,
        border: '1px #D9D5D3 solid',
        color: theme.palette.secondary.main,
        borderRadius: 90,
        fontWeight: 'bold',
      },
    },
    noList: {
      '& ul': {
        paddingLeft: 0,
        margin: 0,
      },
      '& ul li': {
        listStyle: 'none',
        padding: 0,
        margin: 0,
      },
      '& ul li:before': {
        display: 'none',
      },
    },
    lightPinkWrapper: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
    },
    lightPink: {
      backgroundColor: '#FFF4F5',
      padding: '30px 50px',
      '& .MuiTypography-h3': {
        marginLeft: 0,
      },
      [theme.breakpoints.down('sm')]: {
        padding: '10px 5px',
      },
      '& img': {
        width: '90%',
        // marginLeft: '5%',
        marginRight: '10%',
        [theme.breakpoints.down('sm')]: {
          marginLeft: '5%',
          marginRight: '5%',
          marginTop: theme.spacing(2),
        },
      },
    },
    close: {
      float: 'right',
    },
    modal: {
      padding: 20,
    },
    profileImage: {
      width: 1000,
      [theme.breakpoints.down('md')]: {
        width: 720,
      },
      [theme.breakpoints.down('sm')]: {
        width: 400,
      },
      [theme.breakpoints.down('xs')]: {
        width: 300,
      },
    },
  };
};

// class MissionFicheBlock extends Component {
//   constructor(props) {
//     super(props);
//
//     this.state = { overflows: false, show: false, refHeight: 0, height: 'auto' };
//   }
//   componentDidMount() {
//     // console.log('MOUNTED', this.props.more, this.$ref.offsetHeight, HEIGHT_THRESHOLD)
//     // const t = this._getHeightThreshold();
//     // if (this.props.more !== false && this.$ref.offsetHeight > t) {
//     //   this.setState({ overflows: true, refHeight: this.$ref.offsetHeight, height: t });
//     // }
//   }
//   // _getHeightThreshold() {
//   //   const { width, printing } = this.props;
//   //   // console.log(printing)
//   //   // console.log(printing)
//   //   // console.log(printing)
//   //   let t;
//   //   if (printing) t = 'auto';
//   //   else if (width === 'xs') t = 89;
//   //   else t = 119;
//   //   return t;
//   // }
//   // _onClick(e) {
//   //   const t = this._getHeightThreshold();
//   //   this.setState({ show: !this.state.show, height: !this.state.show ? this.state.refHeight : t });
//   // }
//   render() {
//     const { title, content, more, classes } = this.props;
//     const { overflows, show } = this.state;
//     return (
//       <Paper className={'padder' + (overflows ? ' minimal' : '') + (show ? ' show' : '')}>
//         <Typography variant="h4">{title}</Typography>
//         <span dangerouslySetInnerHTML={{ __html: content }}></span>
//       </Paper>
//     );
//   }
// }

class MissionFicheBlockClass extends Component {
  constructor(props) {
    super(props);

    this.state = { overflows: false, show: false, refHeight: 0, height: 'auto' };
  }
  componentDidMount() {
    // console.log('MOUNTED', this.props.more, this.$ref.offsetHeight, HEIGHT_THRESHOLD)
    const t = this._getHeightThreshold();
    // console.log(this.$ref);
    // console.log(this.$ref.offsetHeight, t);
    if (this.props.more !== false && this.$ref.offsetHeight > t) {
      this.setState({ overflows: true, refHeight: this.$ref.offsetHeight, height: t });
    }
  }
  _getHeightThreshold() {
    const { width, printing } = this.props;
    // console.log(printing)
    // console.log(printing)
    // console.log(printing)
    let t;
    if (printing) t = 'auto';
    else if (width === 'xs') t = 89;
    else t = 119;
    return t;
  }
  _onClick = (e) => {
    const t = this._getHeightThreshold();
    this.setState({ show: !this.state.show, height: !this.state.show ? this.state.refHeight : t });
  };
  render() {
    const { title, content, more, classes } = this.props;
    const { overflows, show } = this.state;
    // console.log({ more });
    return (
      <Paper className={classes.paperWrapper}>
        <Typography variant="h4">{title}</Typography>
        <div
          className={clsx(classes.paperContent, {
            [classes.paperHidden]: show !== true,
            [classes.paperOverflows]: overflows === true,
          })}
          style={{ height: this.state.height }}
          ref={(r) => (this.$ref = r)}
          dangerouslySetInnerHTML={{ __html: content }}
        ></div>
        <If condition={more !== false && overflows === true}>
          <If condition={show !== true}>
            <Button
              variant="outlined"
              endIcon={<IconMore />}
              onClick={this._onClick}
              className={classes.paperMore}
            >
              Voir Plus
            </Button>
          </If>
          <If condition={show === true}>
            <Button
              variant="outlined"
              endIcon={<IconLess />}
              onClick={this._onClick}
              className={classes.paperMore}
            >
              Voir Plus
            </Button>
          </If>
        </If>
      </Paper>
    );
  }
}

const MissionFicheBlock = withStyles(styles)(MissionFicheBlockClass);

const MISSION_ID_360 = 'preview';

class MissionFiche extends Component {
  constructor(props) {
    super(props);
    this.state = {
      printing: false,
      autoPlay: false,
      videoUrl: undefined,
      modalState: false,
      videoMore: false,
    };
  }
  componentDidMount() {
    const { missionId, ficheId, profile, anon } = this.props;
    let url;
    if (!anon && !profile) url = config.fiche.replace(':missionId', missionId).replace(':ficheId', ficheId);
    else if (profile) url = config.profile;
    this.props.onMount(url);
    const URI = queryString.parse(this.props.location.search);

    if (URI.print === 'true') {
      document.body.classList.add('print');
      // setTimeout(() => {
      this.setState({ printing: true }, function () {
        //     console.log('ICI');
      });
      // }, 500);
    }
  }
  componentDidUpdate(oldProps) {
    const { missionId, ficheId, profile, anon } = this.props;

    if (
      (oldProps.$$data === undefined && this.props.$$data !== undefined) ||
      (oldProps.$$data !== undefined &&
        this.props.$$data !== undefined &&
        oldProps.$$data.get('fiche').get('id') !== this.props.$$data.get('fiche').get('id'))
    ) {
      const URI = queryString.parse(this.props.location.search);
      // console.log('FIRST (play)')

      if (URI.print === 'true') {
        document.body.classList.add('print');
        this.setState({ printing: true }, function () {
          // console.log('ICI2')
          setTimeout(function () {
            // PRINT
            window.print();
            window.close();
          }, 50);
        });
      } else {
        // console.log('SECOND (play)')
        const { $$data } = this.props;
        const $$fiche = $$data !== undefined ? $$data.get('fiche') : undefined;

        const $$video = $$fiche.get('video_files').get(0);
        // console.log($$video.toJS())
        if ($$video)
          this._playVideo($$video, false);
        else
          this.setState({videoUrl:undefined});
      }
    }

    if (
      (oldProps.missionId !== undefined && oldProps.missionId !== this.props.missionId) ||
      (oldProps.ficheId !== undefined && oldProps.ficheId !== this.props.ficheId)
    ) {
      let url;
      if (!anon && !profile) url = config.fiche.replace(':missionId', missionId).replace(':ficheId', ficheId);
      else if (profile) url = config.profile;

      this.props.onMount(url);
    }
  }
  _modalOpen = () => {
    this.setState({ modalState: true });
  };
  _modalClose = () => {
    this.setState({ modalState: false });
  };
  _hasPrevious() {
    const { missionId } = this.props;
    if (missionId === MISSION_ID_360 || missionId === undefined || missionId === 'anon') return false;
    const currentIndex = this._getFicheIndex(this.props.ficheId);
    return currentIndex !== 0;
  }
  _hasNext() {
    const { $$data, missionId } = this.props;
    if (missionId === MISSION_ID_360 || missionId === undefined || missionId === 'anon') return false;
    const currentIndex = this._getFicheIndex(this.props.ficheId);
    return currentIndex < $$data.get('missions').get('details').size - 1;
  }
  _getFicheIndex(ficheId) {
    const { $$data } = this.props;
    const currentIndex = $$data
      .get('missions')
      .get('details')
      .findIndex((d, i) => {
        return d.get('id') === ficheId;
      });
    return currentIndex;
  }
  _prevNext(direction, missionId, ficheId) {
    const { $$data } = this.props;

    let newFicheId;
    const currentIndex = this._getFicheIndex(ficheId);
    switch (direction) {
      case 'previous':
        if (currentIndex === 0) return;
        else {
          newFicheId = $$data
            .get('missions')
            .get('details')
            .get(currentIndex - 1)
            .get('id');
        }
        break;
      default:
      case 'next':
        if (currentIndex === $$data.get('missions').get('details').size - 1) return;
        else {
          newFicheId = $$data
            .get('missions')
            .get('details')
            .get(currentIndex + 1)
            .get('id');
        }
        break;
    }
    // console.log(newFicheId)
    if (newFicheId) this.props.history.push('/mission/' + missionId + '/fiche/' + newFicheId);
    // console.log('DDDD', this.props.history.push()
  }
  _getVideoUrl($$video, format) {
    let url = false;
    if ($$video.get('urls') === undefined || $$video.get('urls').size === 0) return false;
    $$video.get('urls').map((v) => {
      if (v.get('type') === format) url = v.get('path');
      return true;
    });
    return url;
  }
  _playVideo($$video, autoPlay) {
    const videoUrl = this._getVideoUrl($$video, 'video/mp4');
    if (videoUrl !== false) {
      this.setState({ videoUrl, autoPlay, videoName: $$video.get('name') });
      //console.log('videoUrl is', videoUrl);
    } else {
      console.log('no mp4 found !!!');
    }
  }
  _print() {
    // console.log(this.props.location);
    // const URI = queryString.parse(this.props.location);
    // console.log(URI)
    const URI = this.props.location;
    // console.log('URI IS', URI)
    window.open(
      URI.pathname + '?print=true',
      'Print',
      'width=400, height=200, menubar=no, toolbar=no, left=200, top=100',
    );
  }
  _onVideoMoreClick = (e) => {
    // console.log(e.target);
    e.preventDefault();
    e.stopPropagation();

    if (this.$videoMoreRef && this.$videoMoreRef === e.target) {
      return;
    }

    const { videoMore } = this.state;
    // console.log({ videoMore });
    this.setState({ videoMore: !videoMore });
  };
  render() {
    const { $$data, missionId, ficheId, width, classes } = this.props;
    // const { missionId, ficheId } = this.props;
    // const $$data = undefined;

    const { printing, videoUrl, autoPlay, modalState } = this.state;
    const $$fiche = $$data !== undefined ? $$data.get('fiche') : undefined;
    const $$mission =
      $$data !== undefined && $$data.get('missions') && $$data.get('missions').get('index')
        ? $$data
            .get('missions')
            .get('index')
            .find((obj) => obj.get('id') === missionId)
        : undefined;
    // const $$mission = undefined;

    const hasNext = $$data !== undefined ? this._hasNext() : false;
    const hasPrevious = $$data !== undefined ? this._hasPrevious() : false;

    const showMore = !printing;

    let iconsRowSize = 0;
    if ($$fiche !== undefined) {
      if ($$fiche.get('ville') !== '') iconsRowSize++;
      if ($$fiche.get('salaire') !== '') iconsRowSize++;
      if ($$fiche.get('disponibilite_sous') !== '') iconsRowSize++;
      if ($$fiche.get('permis') !== '') iconsRowSize++;
      // if ($$fiche.get('mobilite') !== '') iconsRowSize++;
    }

    const { videoName, videoMore } = this.state;
    // console.log({ modalState });
    // console.log({ videoUrl, videoName });
    return (
      <Template
        offset={!printing}
        title={
          <Typography variant="h1" className={classes.mainTitle}>
            <If condition={$$fiche !== undefined}>
              <If condition={hasPrevious}>
                <IconButton
                  onClick={this._prevNext.bind(this, 'previous', missionId, ficheId)}
                  className={classes.mainPrevious}
                  size="small"
                >
                  <NavigateBeforeIcon />
                </IconButton>
              </If>
              <div className={classes.inline}>
                <span>Le 360°&nbsp;</span>
                de
              </div>{' '}
              <div className={classes.inline}>
                {$$fiche.get('prenom')} {$$fiche.get('nom')}
              </div>
              <If condition={hasNext}>
                <IconButton
                  onClick={this._prevNext.bind(this, 'next', missionId, ficheId)}
                  className={classes.mainNext}
                  size="small"
                >
                  <NavigateNextIcon />
                </IconButton>
              </If>
            </If>
          </Typography>
        }
      >
        <div className={classes.root}>
          <Choose>
            <When condition={$$fiche !== undefined}>
              <ScrollToTopOnMount />
              <div className={classes.top}>
                <Grid container spacing={0} direction="row" justify="flex-start" alignItems="flex-start">
                  <Grid
                    container
                    spacing={0}
                    direction="row"
                    justify="flex-start"
                    alignItems="flex-start"
                    className="head"
                  >
                    <Grid item xs={12} md={4} className="summary">
                      <Grid
                        container
                        spacing={0}
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                        className={clsx(classes.padderLeftSide)}
                      >
                        <Grid item xs={12} sm={printing !== true ? 7 : 12} md={12}>
                          {/*
                          <Typography variant={'h2'} gutterBottom>
                              <If condition={printing !== true}>
                              <IconButton onClick={this._print.bind(this)} className={classes.printIcon}>
                                <IconPrint className="icon" />
                              </IconButton>
                            </If>
                            Label N°{$$fiche.get('code_candidat')}
                          </Typography>
                          */}
                          <If condition={$$mission}>
                            <Box py={printing !== true ? 2 : 0} px={printing !== true ? 2 : 0}>
                              <Typography variant={'subtitle1'} gutterBottom>
                                <IconButton onClick={this._print.bind(this)} className={classes.printIcon}>
                                  <IconPrint className="icon" />
                                </IconButton>
                                {$$mission.get('code_mission')}
                              </Typography>
                            </Box>
                          </If>

                          <Box py={printing !== true ? 2 : 0} px={printing !== true ? 2 : 0}>
                            <Divider />
                            <Box my={printing !== true ? 3 : 0}>
                              <Typography variant={'subtitle1'} gutterBottom>
                                {$$fiche.get('fonction_str')}
                              </Typography>
                              <If condition={$$mission}>
                                <Typography variant={'h2'} gutterBottom>
                                  <If condition={$$mission.get('type_poste')}>
                                    {$$mission.get('type_poste')}
                                  </If>
                                </Typography>
                              </If>
                            </Box>
                            <Divider />
                          </Box>
                        </Grid>
                        <If condition={printing !== true}>
                          <Grid item xs={12} sm={5} md={12}>
                            <Box py={printing !== true ? 2 : 0} px={2}>
                              <If condition={$$fiche.get('cv') !== undefined && $$fiche.get('cv') !== false}>
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  size="large"
                                  onClick={(e) => window.open($$fiche.get('cv'))}
                                  className={classes.buttonBig}
                                >
                                  Consulter son CV
                                </Button>
                              </If>
                              <If
                                condition={$$fiche.get('test') !== undefined && $$fiche.get('test') !== false}
                              >
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  size="large"
                                  onClick={(e) => {
                                    this._modalOpen();
                                  }}
                                  className={clsx(classes.buttonBig, classes.reversedButton)}
                                >
                                  Son test de personnalité
                                </Button>
                              </If>
                            </Box>
                          </Grid>
                        </If>
                      </Grid>
                    </Grid>

                    <If condition={printing !== true}>
                      <Grid item xs={12} md={8} container align="flex-start" className={classes.videoWrapper}>
                        <Grid item xs={12}>
                          <BlockRatio ratio={'16_9'}>
                            <div className={classes.videoPlaceHolder}>
                              <If condition={videoUrl!==undefined}>
                                <video src={videoUrl} playsInline controls width="100%" height="100%" />
                              </If>
                            </div>
                          </BlockRatio>
                        </Grid>
                        <Grid item xs={12} container alignContent="center">
                          <Grid
                            item
                            xs={$$fiche.get('video_files').size > 1 ? 8 : 12}
                            container
                            alignContent="center"
                          >
                            <Typography variant="subtitle2">{videoName}</Typography>
                          </Grid>
                          <If condition={$$fiche.get('video_files').size > 1}>
                            <Grid
                              item
                              xs={4}
                              container
                              align="center"
                              justify="flex-end"
                              className={classes.videoSelector}
                            >
                              <Button
                                ref={(r) => (this.$videoMoreRef = r)}
                                aria-controls={videoMore ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                endIcon={
                                  <React.Fragment>
                                    <If condition={videoMore === true}>
                                      <IconLess />
                                    </If>
                                    <If condition={videoMore !== true}>
                                      <IconMore />
                                    </If>
                                  </React.Fragment>
                                }
                                className={classes.videoMore}
                                onClick={this._onVideoMoreClick}
                              >
                                Autres vidéos
                              </Button>
                              <Popper
                                open={videoMore}
                                anchorEl={this.$videoMoreRef}
                                role={undefined}
                                transition
                                disablePortal
                              >
                                {({ TransitionProps, placement }) => (
                                  <Grow
                                    {...TransitionProps}
                                    style={{
                                      transformOrigin: placement === 'bottom' ? 'top right' : 'center bottom',
                                    }}
                                  >
                                    <Paper>
                                      <MenuList autoFocusItem={videoMore} id="menu-list-grow">
                                        {$$fiche
                                          .get('video_files')
                                          .map((video, i) => {
                                            return (
                                              <MenuItem
                                                key={'vid_' + i}
                                                onClick={this._playVideo.bind(this, video, true)}
                                              >
                                                <ListItemIcon>
                                                  <IconPlay fontSize="small" />
                                                </ListItemIcon>

                                                {video.get('name')}
                                              </MenuItem>
                                            );
                                          })
                                          .toArray()}
                                      </MenuList>
                                    </Paper>
                                  </Grow>
                                )}
                              </Popper>
                            </Grid>
                          </If>
                        </Grid>
                      </Grid>
                    </If>
                  </Grid>
                </Grid>
              </div>
              <div className="bodyWrapper">
                <Grid container className={classes.iconsRow}>
                  <If condition={$$fiche.get('ville') !== ''}>
                    <Grid item xs={12} sm={6} md={12 / iconsRowSize}>
                      <img src={require('assets/images/icons/icon-ville.svg')} alt="Ville" />
                      <span className={classes.iconLegend}>Ville :</span> {$$fiche.get('ville')}
                    </Grid>
                  </If>

                  <If item condition={$$fiche.get('salaire') !== ''}>
                    <Grid item xs={12} sm={6} md={12 / iconsRowSize}>
                      <img src={require('assets/images/icons/icon-salaire.svg')} alt="Salaire" />
                      <span className={classes.iconLegend}>Salaire :</span> {$$fiche.get('salaire')} K&euro;
                    </Grid>
                  </If>

                  <If condition={$$fiche.get('disponibilite_sous') !== ''}>
                    <Grid item xs={12} sm={6} md={12 / iconsRowSize}>
                      <img src={require('assets/images/icons/icon-preavis.svg')} alt="Préavis" />
                      <span className={classes.iconLegend}>Préavis :</span>{' '}
                      {$$fiche.get('disponibilite_sous')}
                    </Grid>
                  </If>

                  <If condition={$$fiche.get('permis') !== ''}>
                    <Grid item xs={12} sm={6} md={12 / iconsRowSize}>
                      <img src={require('assets/images/icons/icon-permis.svg')} alt="Permis" />
                      <span className={classes.iconLegend}>Permis :</span> {$$fiche.get('permis')}
                    </Grid>
                  </If>
                </Grid>

                <Grid container className={classes.content}>
                  <Grid item xs={12}>
                    <Typography variant={'h3'} gutterBottom>
                      Languages
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    className={clsx(classes.contentRow, { [classes.contentPrinting]: printing === true })}
                  >
                    <Grid item xs={12} sm={6}>
                      <MissionFicheBlock
                        title={'Informatique'}
                        content={$$fiche.get('informatique')}
                        more={showMore}
                        width={width}
                        printing={printing}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MissionFicheBlock
                        title={'Langues'}
                        content={$$fiche.get('langues')}
                        more={showMore}
                        width={width}
                        printing={printing}
                      />
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    container
                    className={clsx({ [classes.contentSpacer]: printing === true })}
                    alignContent="flex-start"
                  >
                    <Grid item xs={12}>
                      <Typography variant={'h3'} gutterBottom>
                        L'avis du recruteur
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      container
                      className={clsx(classes.contentRow, { [classes.contentPrinting]: printing === true })}
                    >
                      <Grid item xs={12} sm={6}>
                        <MissionFicheBlock
                          title={'Formation / Expérience professionnelle'}
                          content={$$fiche.get('avis_formation')}
                          more={showMore}
                          width={width}
                          printing={printing}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MissionFicheBlock
                          title={'Compétences / Savoir-faire'}
                          content={$$fiche.get('avis_competences')}
                          more={showMore}
                          width={width}
                          printing={printing}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} container alignContent="flex-start">
                    <Grid
                      item
                      xs={12}
                      container
                      className={clsx(classes.contentRow, { [classes.contentPrinting]: printing === true })}
                    >
                      <Grid item xs={12} sm={6}>
                        <MissionFicheBlock
                          title={'Personnalité'}
                          content={$$fiche.get('avis_personnalite')}
                          more={showMore}
                          width={width}
                          printing={printing}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MissionFicheBlock
                          title={'Points de vigilance'}
                          content={$$fiche.get('avis_vigilence')}
                          more={showMore}
                          width={width}
                          printing={printing}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    className={clsx(classes.content, classes.lightPinkWrapper)}
                    justify="center"
                  >
                    <Grid
                      item
                      xs={printing !== true ? 10 : 12}
                      container
                      align="flex-start"
                      className={classes.lightPink}
                    >
                      <If condition={printing !== true}>
                        <Grid
                          item
                          container
                          xs={printing !== true ? 2 : false}
                          alignContent="flex-start"
                        >
                          <img
                            src={require('assets/images/icons/icon-perspectives.svg')}
                            alt="Perspectives"
                          />
                        </Grid>
                      </If>
                      <Grid item xs={true} container>
                        <Typography variant={'h3'} gutterBottom style={{ margin: '30px 0 20px' }}>
                          Perspectives dans l'entreprise
                        </Typography>
                        <Grid item xs={12}>
                          <Typography variant="body1">
                            <span
                              dangerouslySetInnerHTML={{ __html: $$fiche.get('avis_perspective') }}
                              className={classes.noList}
                            ></span>
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Modal
                  aria-labelledby="Test de personnalité"
                  aria-describedby="Test de personnalité"
                  open={modalState === true}
                  onClose={this._modalClose}
                >
                  <Paper
                    elevation={3}
                    style={{
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      position: 'absolute',
                    }}
                    className={classes.modal}
                  >
                    <div className="head">
                      <Typography variant="h3" align="enter">
                        <IconButton className={classes.close} onClick={this._modalClose}>
                          <CloseIcon />
                        </IconButton>
                        Test de personnalité
                      </Typography>
                    </div>
                    <div className={classes.profileImage}>
                      <img src={$$fiche.get('test')} width="100%" height="100%" alt="Test" />
                    </div>
                  </Paper>
                </Modal>
              </div>
            </When>
            <Otherwise>
              <div className={'Loading'}>
                <Spinner style={{ marginTop: 200 }}>Chargement...</Spinner>
              </div>
            </Otherwise>
          </Choose>
        </div>
      </Template>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataFiche(state),
    error: getLoadingError(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: (url) => dispatch(fetchData({ key: AF_KEY, fetchUrl: url })),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MissionFiche)));



// WEBPACK FOOTER //
// ./src/components/Mission/MissionFiche.jsx